<template>
  <div>
    <section class="banner-home">
      <div class="banner-content">
        <h2>Política de Privacidade</h2>
      </div>
    </section>

    <section class="section-politica">
      <h1>Política de Privacidade CATENA SYSTEM</h1>
      <div>
        <p>Política de Privacidade - CATENA SYSTEM</p>
        <p>1. Introdução</p>
        <p>
          A CATENA SYSTEM respeita a privacidade de todos os usuários e clientes, comprometendo-se a proteger todas as informações pessoais que nos forem fornecidas. Esta Política de Privacidade descreve como coletamos, utilizamos, armazenamos e protegemos suas informações ao utilizar nosso site e
          nossos serviços.
        </p>
        <p>2. Informações que Coletamos</p>
        <p>Ao entrar em contato conosco através do formulário de contato, coletamos as seguintes informações:</p>
        <ul>
          <li>Nome completo</li>
          <li>Endereço de e-mail</li>
          <li>Número de telefone (opcional)</li>
          <li>Assunto e conteúdo da mensagem</li>
        </ul>
        <p>Esses dados são coletados para fins específicos de comunicação com os clientes e usuários interessados em nossos serviços.</p>
        <p>3. Como Utilizamos Suas Informações</p>
        <p>Utilizamos os dados coletados para os seguintes propósitos:</p>
        <ul>
          <li>Responder às suas dúvidas, solicitações ou fornecer informações sobre nossos serviços.</li>
          <li>Entrar em contato para fornecer suporte ou informações adicionais sobre a CATENA SYSTEM.</li>
          <li>Personalizar nossa comunicação de acordo com seus interesses e necessidades.</li>
        </ul>
        <p>Não utilizamos seus dados para fins de marketing direto sem o seu consentimento prévio.</p>
        <p>4. Compartilhamento de Informações</p>
        <p>A CATENA SYSTEM não compartilha, vende, ou divulga suas informações pessoais a terceiros, exceto quando:</p>
        <ul>
          <li>For necessário para o cumprimento de uma obrigação legal.</li>
          <li>Tiver o seu consentimento explícito.</li>
          <li>Estivermos utilizando fornecedores ou parceiros de tecnologia que nos ajudam a operar o site, realizar nossos serviços ou processar dados (nesses casos, esses terceiros são obrigados a proteger suas informações e não utilizá-las para outros fins).</li>
        </ul>
        <p>5. Segurança das Informações</p>
        <p>Tomamos medidas técnicas e organizacionais para proteger suas informações pessoais contra perda, uso indevido, acesso não autorizado, divulgação, alteração ou destruição. Todas as informações pessoais que coletamos são armazenadas de forma segura, utilizando práticas padrão do setor.</p>
        <p>6. Tempo de Retenção de Dados</p>
        <p>Manteremos suas informações pessoais somente pelo tempo necessário para cumprir as finalidades descritas nesta Política de Privacidade, a menos que um período de retenção mais longo seja exigido ou permitido por lei.</p>
        <p>7. Seus Direitos</p>
        <p>Você tem o direito de:</p>
        <ul>
          <li>Solicitar o acesso às suas informações pessoais.</li>
          <li>Solicitar correções ou atualizações nas informações que temos sobre você.</li>
          <li>Solicitar a exclusão de seus dados pessoais, sujeito a limitações legais ou contratuais.</li>
          <li>Retirar seu consentimento para o uso de seus dados, quando aplicável.</li>
        </ul>
        <p>Se desejar exercer algum desses direitos, entre em contato conosco pelo e-mail: darley.dias@roboflex.com.br.</p>
        <p>8. Cookies e Tecnologias de Rastreamento</p>
        <p>Nosso site pode utilizar cookies para melhorar a experiência do usuário. Cookies são pequenos arquivos de texto que podem ser usados por sites para tornar a experiência do usuário mais eficiente. Se preferir, você pode desativar os cookies no seu navegador.</p>
        <p>9. Alterações na Política de Privacidade</p>
        <p>
          A CATENA SYSTEM reserva-se o direito de modificar esta Política de Privacidade a qualquer momento. Quaisquer alterações serão publicadas nesta página, com a data da última atualização. Recomendamos que revise esta política periodicamente para estar sempre ciente de como estamos protegendo
          suas informações.
        </p>
        <p>10. Contato</p>
        <p>Se você tiver alguma dúvida ou preocupação sobre esta Política de Privacidade ou sobre o tratamento de suas informações pessoais, entre em contato conosco através do e-mail: darley.dias@roboflex.com.br.</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.banner-home {
  background: url("../assets/banner-home.jpg") no-repeat center center/cover;
  width: 100vw;
  height: 80vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: -50px;
}

h1 {
  font-size: 2.5em;
  margin-bottom: 10px;
}

h2 {
  font-size: 1.8em;
  margin-bottom: 20px;
}

p {
  font-size: 1em;
  margin-bottom: 30px;
  text-align: left;
  margin: 20px 80px 0px 80px;
}
li {
  text-align: left;
  margin: 20px 0px 0px 80px;
}
.section-politica {
  color: #274862;
  margin: 80px;
}

.section-politica h1 {
  margin-bottom: 50px;
}
@media (max-width: 1024px) {
  .banner-content h1 {
    font-size: 2.2em;
  }
}

@media (max-width: 768px) {
  .banner-content {
    max-width: 90%;
    padding: 20px;
  }

  .banner-content h2 {
    font-size: 1.4em;
  }
}

@media (max-width: 480px) {
  .banner-content h2 {
    font-size: 1.2em;
  }
}
</style>
